import { colorsPalettes } from "@similarweb/styles";
import type { IDraggableItem } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import {
    DragHandleStyled,
    SingleDirectionDragAndDropStyled,
} from "app/components/compare/WebsiteQueryBar/WebsiteQueryBar";
import { translate } from "app/filters/i18nFilter";

import type { IAddBrandsButton } from "./AddBrandsButton";
import { AddBrandsButton } from "./AddBrandsButton";
import type { IBrandChip } from "./BrandChip";
import { BrandChip } from "./BrandChip";
import { BrandChipItem, getDragBox } from "./BrandsQuerybar.styled";
import { MAX_BRANDS_SELECTED } from "./consts";

const VS = () => {
    return (
        <Text
            fontVariant="body1"
            color={colorsPalettes.carbon[300]}
            style={{ margin: "0 16px" }}
        >
            {translate("common.vs")}
        </Text>
    );
};

interface IBrandsQueryBar {
    campaignBrand: string;
    competitorBrands: string[];
    selectedCompetitorBrands: string[];
    onAddBrand: IAddBrandsButton["onAddBrand"];
    onRemoveBrand: IBrandChip["onRemoveBrand"];
    onUpdateBrand: IBrandChip["onUpdateBrand"];
    onDragEnd: (items: IDraggableItem[]) => void;
}

export const BrandsQueryBar = ({
    campaignBrand,
    competitorBrands,
    selectedCompetitorBrands,
    onAddBrand,
    onRemoveBrand,
    onUpdateBrand,
    onDragEnd,
}: IBrandsQueryBar) => {
    const unselectedBrands = competitorBrands.filter((brand) => !selectedCompetitorBrands.includes(brand));
    const isMaxBrandsSelected = selectedCompetitorBrands?.length === MAX_BRANDS_SELECTED;
    return (
        <Flex
            gap="8px"
            width="100%"
            alignItems="center"
        >
            <BrandChipItem
                text={translate("llm.brand.multiple")}
                hideRemoveButton
                isDisabled
                image={""}
                isCompare={true}
                onItemClick={undefined}
                width="100px"
                renderImageComponent={() => <div style={{ padding: "4px" }} />}
            />
            {selectedCompetitorBrands?.length > 0 ? <VS /> : null}
            {selectedCompetitorBrands?.length > 1 ? (
                <SingleDirectionDragAndDropStyled
                    className="u-flex-row u-flex-center"
                    direction="horizontal"
                    items={selectedCompetitorBrands
                        .map((selectedBrand) => (
                            <div key={selectedBrand}>
                                <DragHandleStyled />
                                <BrandChip
                                    unselectedBrands={unselectedBrands}
                                    onUpdateBrand={onUpdateBrand}
                                    onRemoveBrand={onRemoveBrand}
                                    selectedBrand={selectedBrand}
                                />
                            </div>
                        ))
                        .map((c) => ({ id: c.key, component: c, isDragDisabled: false }))}
                    getItemComponent={(_, isDragging: boolean) => getDragBox(isDragging)}
                    onDragEnd={onDragEnd}
                />
            ) : (
                selectedCompetitorBrands.map((selectedBrand) => (
                    <BrandChip
                        key={selectedBrand}
                        unselectedBrands={unselectedBrands}
                        onUpdateBrand={onUpdateBrand}
                        onRemoveBrand={onRemoveBrand}
                        selectedBrand={selectedBrand}
                    />
                ))
            )}
            {isMaxBrandsSelected ? null : (
                <AddBrandsButton
                    unselectedBrands={unselectedBrands}
                    onAddBrand={onAddBrand}
                />
            )}
        </Flex>
    );
};
